import {
    GET_BANKING_ALERTS_FAILED, GET_BANKING_ALERTS_PENDING, GET_BANKING_ALERTS_FULFILLED,
    UPDATE_BANKING_ALERT_VALUES, ADD_BANKING_ALERT_VALUE, ADD_CURRENT_OPERATING_VALUE, UPDATE_DELIVERY_CHANNEL,
    GET_CONTACT_PREFERENCES_FULFILLED,
} from '../actions/actionTypes'
import { LoadingState } from '../helpers/enum'

const initialState = {
    items: [],
    addItem: {
        currentAddItemType: ''
    },
    editItem: {
        currentEditItemId: '',
        currentEditItemType: '',
        currentEditItemValue: ''
    },
    deliveryChannelConfig: [],
    bankingAlertsState: '',
}

export default function bankingAlertsReducer(state = initialState, action) {
    switch (action.type) {
        case GET_BANKING_ALERTS_PENDING:
            return {
                ...state,
                bankingAlertsState: LoadingState.PENDING,
                contactPreferenceState: '',
                addItem: {
                    currentAddItemType: ''
                },
                editItem: {
                    currentEditItemId: '',
                    currentEditItemType: '',
                    currentEditItemValue: ''
                }
            }

        case GET_CONTACT_PREFERENCES_FULFILLED:
            return {
                ...state,
                contactPreferenceState: LoadingState.FULFILLED
            }
        case GET_BANKING_ALERTS_FAILED:
            return {
                ...state,
                bankingAlertsState: LoadingState.FAILED,
                addItem: {
                    currentAddItemType: ''
                },
                editItem: {
                    currentEditItemId: '',
                    currentEditItemType: '',
                    currentEditItemValue: ''
                }
            }
        case GET_BANKING_ALERTS_FULFILLED:
            return {
                ...state,
                bankingAlertsState: LoadingState.FULFILLED,
                items: action.data,
                addItem: {
                    currentAddItemType: '',
                    currentAddItemValue: ''
                },
                editItem: {
                    currentEditItemId: '',
                    currentEditItemType: '',
                    currentEditItemValue: ''
                }
            }
        case ADD_BANKING_ALERT_VALUE:
            return {
                ...state,
                addItem: {
                    ...state.addItem,
                    ...action.payload
                }
            }
        case UPDATE_BANKING_ALERT_VALUES:
            return {
                ...state,
                editItem: {
                    ...state.editItem,
                    ...action.payload
                }
            }
        case ADD_CURRENT_OPERATING_VALUE:
            return {
                ...state,
                currentValue: action.payload
            }
        case UPDATE_DELIVERY_CHANNEL:
            return { ...state, deliveryChannelConfig: action.deliveryChannels }


        default:
            return state;
    }

}